var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#B5B5B5",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 13.818,
    x: 7.636,
    y: 1.091,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.818,
    height: 1,
    x: 1.091,
    y: 7.636,
    rx: 0.5
  }))));
}

export default __webpack_public_path__ + "cedc6fe4ff91fae7cea30d3b10ceda6b.svg";
export { SvgIconAdd as ReactComponent };